import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a137ade0&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a137ade0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a137ade0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a137ade0')) {
      api.createRecord('a137ade0', component.options)
    } else {
      api.reload('a137ade0', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a137ade0&scoped=true&", function () {
      api.rerender('a137ade0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28UhMlq8SYZHa/JS/teamMember.vue"
export default component.exports